// extracted by mini-css-extract-plugin
export var loadingSpinner = "_10-0";